import { createAction } from "@reduxjs/toolkit";

export const getCatalogsAction = createAction("getCatalogsAction");
